<template>
  <div>
    <v-simple-table fixed-header>
      <template>
        <thead>
          <tr>
            <th class="text-center" style="width: 50px">ID</th>
            <th class="text-left">名前</th>
            <th class="text-left">ユーザータイプ</th>
            <th class="text-left">登録メールアドレス</th>
            <th class="text-left">最終ログイン日時</th>
            <th class="text-left">サイト権限</th>
            <th class="text-left">支払い情報</th>
            <MasterAdminPermissionGuardContainer
              :tag="'th'"
              class="text-left"
            />
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in users" :key="user.id">
            <td class="text-center">
              {{ user.id }}
            </td>
            <td v-if="isUserInviting(user)">
              <v-chip small> 招待中</v-chip>
              <v-btn small text plain color='primary' @click="reinviteUserAuth(user.id)"
                >招待メールを再送する</v-btn
              >
            </td>
            <td v-else>
              {{ user.name }}
              <v-chip
                v-if="!isPaymentInformationEdited(user) && !isClient(user)"
                color="error"
                class="ml-1 px-1"
                outlined
                x-small
                label
                >支払情報未設定
              </v-chip>
            </td>
            <td v-if="isAdmin(user)">最高管理者</td>
            <td v-if="isManager(user)">管理者</td>
            <td v-if="isWriter(user)">ライター</td>
            <td v-if="isClient(user)">クライアント</td>
            <td>{{ user.email }}</td>
            <td>
              {{ user.currentSignInAt | moment }}
            </td>
            <td>
              <v-btn
                v-if="!isUserInviting(user)"
                small
                color="primary"
                @click="editUserAuth(user)"
                >編集
              </v-btn>
            </td>
            <td>
              <v-btn
                v-if="isWriter(user)"
                small
                class="black--text"
                color="warning"
                :to="{
                  name: 'masterAdminUserAuthEdit',
                  params: { id: user.id },
                }"
                >編集
              </v-btn>
            </td>
            <MasterAdminPermissionGuardContainer :tag="'td'">
              <v-menu bottom right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-card tile flat>
                  <v-list nav dense>
                    <v-list-item @click="revokeMasterAccess(user.id)">
                      <v-list-item-content>
                        <v-list-item-title>マスター権限削除</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                      color="danger"
                      @click="deleteUserAuth(user.id)"
                    >
                      <v-list-item-content>
                        <v-list-item-title class="danger--text">
                          ユーザー削除
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-menu>
            </MasterAdminPermissionGuardContainer>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import MasterAdminPermissionGuardContainer from '/src/container/shared/MasterAdminPermissionGuardContainer'
import moment from 'moment'
import axios from 'axios'

export default {
  components: { MasterAdminPermissionGuardContainer },
  filters: {
    moment: function (val) {
      if (val) {
        return moment(val).format('YYYY年M月D日 HH時mm分')
      }
    }
  },
  props: {
    users: {
      type: Array,
      required: true
    }
  },
  methods: {
    editUserAuth (user) {
      this.$emit('editUserAuth', user)
    },
    isAdmin (user) {
      return user.masterAccess == 'admin'
    },
    isManager (user) {
      return user.masterAccess == 'manager'
    },
    isWriter (user) {
      return user.masterAccess == 'writer'
    },
    isClient (user) {
      return user.masterAccess == 'client'
    },
    isUserInviting (user) {
      return user.invitationSentAt && user.invitationAcceptedAt == null
    },
    isPaymentInformationEdited (user) {
      if (this.isAdmin(user) || this.isManager(user)) {
        return true
      }
      return ['paymentEntity', 'paymentName'].every((key) => user[key])
    },
    revokeMasterAccess (userAuthId) {
      if (!confirm('マスターユーザーの権限を削除してよろしいでしょうか？')) {
        return
      }

      axios
        .patch(`/api/master/user_auths/${userAuthId}/revoke_master_accesses`)
        .then(
          () => {
            const payload = {
              status: 200,
              message: '権限を削除しました'
            }
            this.$emit('update-users')
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.data.message.toString()
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
    },
    deleteUserAuth (userAuthId) {
      if (!confirm('ユーザーを削除してよろしいでしょうか？')) return

      axios.delete(`/api/master/user_auths/${userAuthId}`).then(
        () => {
          const payload = {
            status: 200,
            message: 'ユーザーを削除しました'
          }
          this.$emit('update-users')
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        },
        (error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.message.toString()
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    },
    reinviteUserAuth (userAuthId) {
      if (!confirm('招待メールを送信してよろしいでしょうか？')) return

      axios.patch(`/api/master/user_auths/invitations/${userAuthId}`).then(
        () => {
          const payload = {
            status: 200,
            message: '招待メールを送信しました'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        },
        (error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.message.toString()
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    }
  }
}
</script>

<style scoped>
th,
td {
  vertical-align: middle;
}
</style>
